import React from "react";
import PropTypes from "prop-types";
import { isDesktop } from "../../utils";
import PdpDesktopAccordion from "./Desktop";
import PdpMobileAccordion from "./Mobile";

function PdpAccordion(props) {
  const desktop = isDesktop;
  const { PdpData } = props;
  if (PdpData) {
    if (desktop) {
      return <PdpDesktopAccordion PdpData={PdpData} />;
    }
    return <PdpMobileAccordion PdpData={PdpData} />;
  }
  return <div />;
}

PdpAccordion.defaultProps = {
  PdpData: {},
};

PdpAccordion.propTypes = {
  PdpData: PropTypes.shape({}),
};
export default PdpAccordion;



// WEBPACK FOOTER //
// ./src/component/PdpAccordion/index.js